export const MODAL_TYPE_CATEGORIES_MANAGER = 'categories-manager';
